import Vue from 'vue';

Vue.component('measurement-index', () =>
    import(/* webpackChunkName: 'measurement-index' */ './measurement-index.vue'),
);
